import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
const FanMember = () => {

  const { imageCdnUrl } = useContext(serverInfo);

  const [fanDetails, setFanDetails] = React.useState([]);
  const [myStar, setMyStar] = useState([]);
  const [anotherStar, setAnotherStar] = useState([]);

  // const [myAnotherStar, setMyAnotherStar] = React.useState('');
  const { slug } = useParams();

  useEffect(() => {
    axios.get(`/api/user/fan/group/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);

        setMyStar(res.data.my_user_join);
        setAnotherStar(res.data.another_user_join);

        // setMyAnotherStar(res.data.fanDetails.another_user_join);
      }
    });
  }, [slug]);

  return (
    <>
      <div className="MediaBG mt-3">
        <div className="row ms-1 me-1">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Nav variant="pills" className="d-flex mx-2 mt-3">
              <Nav.Item>
                <Nav.Link eventKey="first" className="me-3 NavMember">
                  Members{" "}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second" className="me-3 NavMember">
                  {" "}
                  Admins
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/*______________________ Member ___________________*/}
              <Tab.Pane eventKey="first">
                <div className="row justify-content-between mx-2 mt-3 mb-3">
                  <div className="col-md-6 px-2 MembersListFan">
                    <button className="btn w-100 ">
                      <img
                        src={imageCdnUrl + fanDetails.my_superstar?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name} - {myStar.length}
                      {/* - 130 */}
                    </button>
                  </div>
                  <div className="col-md-6 px-2 MembersListFanAdmin">
                    <button className="btn w-100 ">
                      <img
                        src={imageCdnUrl + fanDetails.another_superstar?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name} -{" "}
                      {anotherStar.length}
                    </button>
                  </div>
                </div>

                {/*______________________ Admin List ___________________*/}

                <div className="row justify-content-between mx-2 mt-3  FanMemberScroll">
                  <div className="col-md-6 px-2 MembersListFanUser mb-3">
                    {/*____________ Salman Khan Admin ____________ */}

                    {myStar.map((fan, i) => (
                      <button className="btn w-100 text-light FaNMemBerList mb-3">
                        <img
                          src={imageCdnUrl + fan.image}
                          alt=""
                          className="MemImgStar"
                        />
                        {fan.first_name} {fan?.last_name}
                      </button>
                    ))}
                  </div>

                  <div className="col-md-6  px-2 MembersListFanUser mb-3">
                    {/*____________ Shahrukh Khan Admin ____________ */}

                    {anotherStar.map((fan, i) => (
                      <button className="btn w-100 text-light FaNMemBerList mb-3">
                        <img
                          src={imageCdnUrl + fan.image}
                          alt=""
                          className="MemImgStar"
                        />
                        {fan.first_name} {fan?.last_name}
                      </button>
                    ))}
                  </div>
                </div>
              </Tab.Pane>

              {/*______________________ Admin ___________________*/}

              <Tab.Pane eventKey="second">
                <div className="row justify-content-between mx-2 mt-3 mb-3">
                  <div className="col-md-6 px-2 MembersListFan">
                    <button className="btn w-100 MembersListFan ">
                      <img
                        src={imageCdnUrl + fanDetails.my_superstar?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name} - 1
                    </button>
                  </div>
                  <div className="col-md-6 px-2 MembersListFanAdmin">
                    <button className="btn w-100 ">
                      <img
                        src={imageCdnUrl + fanDetails.another_superstar?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name} - 1
                    </button>
                  </div>
                </div>

                {/*______________________ Admin List ___________________*/}

                <div className="row justify-content-between mx-2 mt-3  FanMemberScroll">
                  <div className="col-md-6 px-2 MembersListFanUser mb-3">
                    {/*____________ Salman Khan Admin ____________ */}
                    <button className="btn w-100 text-light FaNMemBerList mb-3">
                      <img
                        src={imageCdnUrl + fanDetails.my_admin?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.my_admin?.first_name}{" "}
                      {fanDetails.my_admin?.last_name}
                    </button>
                  </div>

                  <div className="col-md-6  px-2 MembersListFanUser mb-3">
                    {/*____________ Shahrukh Khan Admin ____________ */}
                    <button className="btn w-100 text-light FaNMemBerList">
                      <img
                        src={imageCdnUrl + fanDetails.another_admin?.image}
                        alt=""
                        className="MemImgStar"
                      />
                      {fanDetails.another_admin?.first_name}{" "}
                      {fanDetails.another_admin?.last_name}
                    </button>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default FanMember;
